function Informatique(){

    return(
 <article className="flex-wrap-center">
              <div className="icon"><img src="/img/icons/html5.svg"/><p>HTML 5</p></div>
              <div className="icon"><img src="/img/icons/css.svg"/><p>CSS</p></div>
              <div className="icon"><img src="/img/icons/js.svg"/><p>JS</p></div>
              <div className="icon"><img src="/img/icons/php.svg"/><p>PHP</p></div>
              <div className="icon"><img src="/img/icons/react.svg"/><p>REACT</p></div>
              <div className="icon"><img src="/img/icons/vuejs.svg"/><p>Vue.js</p></div>
              <div className="icon"><img id="nodejs" src="/img/icons/nodejs-white.png"/><p>NodeJS</p></div>
              <div className="icon"><img src="/img/icons/tailwind.png"/><p>TailWind</p></div>
              <div className="icon"><img id ="pma" src="/img/icons/PhpMyAdmin_logo.png"/><p>PHPMyAdmin</p></div>
              <div className="icon"><img id="mysql" src="/img/icons/mysql-white.png"/><p>MySQL</p></div>
              <div className="icon"><img src="/img/icons/git.svg"/><p>Git</p></div>
              <div className="icon"><img src="/img/icons/docker.svg"/><p>Docker</p></div>
            </article>
    )
}
export default Informatique